import { MemberDeadContent } from "../../components/kaya"

export default function MemberDead () {

  return (

    <>
        <MemberDeadContent/>
    </>

  )

}